import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setInfoForEventDetailsPage, changeEventDetailsFilter, cancelCredential } from '../../actions';
import { Link } from 'react-router';
import EventDetails from '../../components/Events/EventDetails'
import emptyCredentials from '../../../html/assets/images/empty-credentials.png';
import emptyCredentials2x from '../../../html/assets/images/empty-credentials@2x.png';
import {COTA_DISCLAIMER} from '../../constants';

class Event extends Component {

  componentDidMount() {
    this.props.setInfoForEventDetailsPage(this.props.params.id)
  }

  render() {
    const {eventDetails, changeEventDetailsFilter, cancelCredential, params} = this.props;
    const showAddButton = eventDetails.eventId !== "manually-assigned-credentials";
    const noAssignedCredentials = eventDetails.assignedCredentials.length === 0;
    const hasDisclaimer = false; // params.id === "Round9";
    
    return (
      <div>
        <div className="track-lg" data-track={eventDetails.trackName}></div>
        <div className="container">
          <div className="row row-head">
            <Link to="/dashboard" className="pull-left">
              <div className="icon-white_arrow_back"></div>
            </Link>
            {showAddButton &&
              <Link to="/request" className="btn btn-primary btn-round pulse pull-right">
                <div className="icon-white_add"></div>
              </Link>
            }
            <div className="col-xs-12 col-md-8 col-md-offset-2">
              <h5>{eventDetails.name}</h5>{eventDetails.schedule}
            </div>
          </div>

          {hasDisclaimer && <div style={{ color: 'white', border: 'solid 1px white', marginBottom: 10, padding: 10 }}>
            {COTA_DISCLAIMER}
          </div>}

          {noAssignedCredentials ? <EmptyCredentials /> : <EventDetails
            eventDetails={eventDetails}
            changeEventDetailsFilter={changeEventDetailsFilter}
            cancelCredential={cancelCredential}
          />}

        </div>
      </div>
    )
  }
}

const EmptyCredentials = () => (
  <div className="text-center margin-top">
    <img src={emptyCredentials} srcSet={`${emptyCredentials} 1x, ${emptyCredentials2x} 2x`} alt="empty-credentials" />
      <h4>Request credentials for this round</h4>
  </div>
);

const mapStateToProps = ({eventDetails}) => ({eventDetails});


function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setInfoForEventDetailsPage, changeEventDetailsFilter, cancelCredential }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Event);



// WEBPACK FOOTER //
// ./src/containers/Event/index.js